import { FEED_CONSTANTS } from '../constants/feed.constants';

export function getRelativeTime(dateString: string): string {
  const { JUST_NOW, MINUTE, MINUTES, HOUR, DAY, WEEK, MONTH, YEAR, AGO } =
    FEED_CONSTANTS;
  const now = new Date();
  const postDate = new Date(dateString);
  const diffInMs = now.getTime() - postDate.getTime();

  // Convert to different time units
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const diffInWeeks = Math.floor(diffInDays / 7);
  const diffInMonths = Math.floor(diffInDays / 30);
  const diffInYears = Math.floor(diffInDays / 365);

  // Handle future dates
  if (diffInMs < 0) {
    return JUST_NOW;
  }

  // Less than 1 minute
  if (diffInMinutes < 1) {
    return JUST_NOW;
  }

  // Less than 1 hour - show minutes
  if (diffInMinutes < 2) {
    return `${diffInMinutes} ${MINUTE} ${AGO}`;
  }

  if (diffInMinutes >= 2 && diffInMinutes < 60) {
    return `${diffInMinutes} ${MINUTES} ${AGO}`;
  }

  // Less than 24 hours - show hours
  if (diffInHours < 24) {
    return `${diffInHours} ${HOUR} ${AGO}`;
  }

  // Less than 7 days - show days
  if (diffInDays < 7) {
    return `${diffInDays} ${DAY} ${AGO}`;
  }

  // Less than 30 days - show weeks
  if (diffInDays < 30) {
    return `${diffInWeeks} ${WEEK} ${AGO}`;
  }

  // Less than 365 days - show months
  if (diffInDays < 365) {
    return `${diffInMonths} ${MONTH} ${AGO}`;
  }

  // Show years
  return `${diffInYears} ${YEAR} ${AGO}`;
}

// Usage example:
// const timeAgo = getRelativeTime("2025-07-13T00:23:37.225Z");
// console.log(timeAgo); // e.g., "2 hours ago"
